import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text, getPaletteColor } from 'pcln-design-system'

import StopItem from './StopItem'

/** = Styles */
const StopsBox = styled(Flex)`
  padding: 0 4px;
  flex-direction: column;
  justify-content: center;
  font-size: 10px;
  font-weight: 500;
  color: ${getPaletteColor('text.light')};

  ${(props) => props.theme.flyQueries.tablet} {
    ${(props) => (props.isShelfItinerary ? 'padding: 0 8px 12px 8px;' : 'padding: 0 8px;')}
  }
`

const Separator = styled(Box)`
  position: relative;
  width: 64px;
  height: 1px;
  border-top: 1px solid ${getPaletteColor('border.dark')};

  ${(props) => props.theme.flyQueries.mobilelg} {
    width: 72px;
  }

  ${(props) => props.theme.flyQueries.tablet} {
    width: 80px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    width: 120px;
  }

  ${(props) => props.theme.flyQueries.desktophd} {
    width: 128px;
  }
`

const StopsTextAlways = styled(Text.span)`
  font-size: 10px;
  line-height: 12px;
  color: ${getPaletteColor('text.light')};
  text-align: center;
  text-transform: capitalize;
  margin-top: 4px;

  ${(props) => props.theme.flyQueries.desktoplg} {
    font-size: 11px;
  }
`

const StopsText = styled(StopsTextAlways)`
  margin-top: 0;

  ${(props) => props.theme.flyQueries.desktoplg} {
    display: none;
  }
`

function Stops(props) {
  const { number, layoverInfo = [], isShelfItinerary } = props
  const stopItems = layoverInfo.map((layover, index) => {
    return (
      <StopItem
        key={index}
        duration={layover?.duration}
        location={layover?.airport?.code}
        stopTitle={layover?.airport?.name}
        isShelfItinerary={isShelfItinerary}
      />
    )
  })
  const shouldShowStopDots = number > 0 && number < 3
  const StopTextComponent = shouldShowStopDots ? StopsText : StopsTextAlways

  return (
    <StopsBox data-test='stops-box' isShelfItinerary={isShelfItinerary}>
      <Separator />
      {number > 2 ? null : (
        <Flex data-test='stops-items' justify='space-around' justifyContent='space-around'>
          {stopItems}
        </Flex>
      )}
      <StopTextComponent data-test='stops-text-component'>{props.stopsText}</StopTextComponent>
    </StopsBox>
  )
}

Stops.propTypes = {
  number: PropTypes.number.isRequired,
  stopsText: PropTypes.string.isRequired,
  layoverInfo: PropTypes.array,
  isShelfItinerary: PropTypes.bool,
}

export default Stops
